import { POLICIES_APIS } from "libs/apis/policies.api";
import { TEAM_MEMBER_APIS } from "libs/apis/team-members.api";
import { useNavigate } from "react-router-dom";

const usePolicies = () => {
  const navigate = useNavigate();
  const getPolicies = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function,
    setTotalElements?: Function
  ) => {
    const response = await POLICIES_APIS.getPolicies(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
        pageNumber = 0,
        pageSize = 10,
        totalElements = 0,
      } = data;
      setData(content);
      setFilters((prev) => ({
        ...prev,
        page: pageNumber + 1,
        limit: pageSize,
      }));
      setTotalElements?.(totalElements);
    }
  };

  const getTeamMemberByID = async (id: number, setUser: Function) => {
    const response = await TEAM_MEMBER_APIS.getTeamMemberByID(id);
    const { status = false, data = {} } = response || {};
    if (status) {
      setUser(data);
    }
  };

  const editPolicyByID = async (id: number, queryParams: any = {}) => {
    const response = await POLICIES_APIS.editPolicyByID(id, queryParams);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const getPolicyByID = async (setData: Function, body: any ) => {
    const response = await POLICIES_APIS.getPolicies(body);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const { content = [] } = data;
      setData(content);
    }
  };


  

  return {
    getPolicies,
    getTeamMemberByID,
    editPolicyByID,
    getPolicyByID,
  };
};

export default usePolicies;
